import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import enfermeriaImg from '../../assets/general.jpg';

const Enfermeria24Horas = () => {
  const pageData = {
    title: "Enfermería 24 Horas",
    metaDescription: "Servicio de enfermería a domicilio las 24 horas en Guadalajara. Personal certificado disponible día y noche para cuidados médicos continuos.",
    heroTitle: "Enfermería a Domicilio 24 Horas",
    heroSubtitle: "Atención médica profesional sin interrupciones, los 365 días del año en la comodidad de tu hogar",
    description: "Nuestro servicio de enfermería 24 horas está diseñado para pacientes que requieren atención médica continua. Contamos con personal rotativo que garantiza cuidados profesionales durante todo el día y la noche, ideal para pacientes postoperatorios, terminales o con condiciones crónicas que requieren monitoreo constante.",
    benefits: [
      "Personal de enfermería rotativo para cobertura continua",
      "Monitoreo de signos vitales cada 4 horas",
      "Administración de medicamentos en horarios exactos",
      "Atención de emergencias inmediata",
      "Coordinación con médicos tratantes",
      "Reportes diarios para familiares",
      "Cambios de posición y prevención de escaras",
      "Higiene y alimentación asistida"
    ],
    features: [
      {
        title: "Turnos Rotativos",
        description: "Personal fresco cada 12 horas para garantizar atención óptima en todo momento"
      },
      {
        title: "Comunicación Continua",
        description: "Línea directa 24/7 para familiares y coordinación con equipo médico"
      },
      {
        title: "Equipamiento Completo",
        description: "Traemos todo el equipo necesario: baumanómetro, oxímetro, glucómetro, etc."
      },
      {
        title: "Protocolos de Emergencia",
        description: "Personal capacitado para actuar ante cualquier eventualidad"
      },
      {
        title: "Registro Detallado",
        description: "Bitácora digital con todos los eventos y signos vitales"
      },
      {
        title: "Flexibilidad de Horarios",
        description: "Adaptamos los turnos según las necesidades de cada familia"
      }
    ],
    faqs: [
      {
        question: "¿Cómo funcionan los turnos de 24 horas?",
        answer: "Trabajamos con turnos rotativos de 12 horas. Dos enfermeras se alternan para que siempre haya personal descansado y atento cuidando a tu familiar."
      },
      {
        question: "¿Qué incluye el servicio de enfermería 24 horas?",
        answer: "Incluye: monitoreo continuo de signos vitales, administración de medicamentos, cambios de posición, alimentación asistida, higiene personal, curaciones, reportes diarios y atención de emergencias."
      },
      {
        question: "¿Cuánto cuesta el servicio de 24 horas?",
        answer: "El costo depende de las necesidades específicas del paciente. Contáctanos para una evaluación gratuita y cotización personalizada."
      },
      {
        question: "¿Qué pasa si hay una emergencia durante la noche?",
        answer: "Nuestra enfermera está capacitada para estabilizar al paciente y coordinar inmediatamente con servicios de emergencia si es necesario. También contamos con línea de supervisión 24/7."
      }
    ],
    image: enfermeriaImg,
    relatedBlogSlugs: ['enfermeria-domicilio-guadalajara-2026', 'signos-alarma-adultos-mayores']
  };

  return <ServiceLandingPage {...pageData} />;
};

export default Enfermeria24Horas;
